function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module mention/mentionediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { uid } from 'ckeditor5/src/utils';
import MentionCommand from './mentioncommand';
/**
 * The mention editing feature.
 *
 * It introduces the {@link module:mention/mentioncommand~MentionCommand command} and the `mention`
 * attribute in the {@link module:engine/model/model~Model model} which renders in the {@link module:engine/view/view view}
 * as a `<span class="mention" data-mention="@mention">`.
 *
 * @extends module:core/plugin~Plugin
 */

var MentionEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(MentionEditing, _Plugin);

  var _super = _createSuper(MentionEditing);

  function MentionEditing() {
    _classCallCheck(this, MentionEditing);

    return _super.apply(this, arguments);
  }

  _createClass(MentionEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var model = editor.model;
      var doc = model.document; // Allow the mention attribute on all text nodes.

      model.schema.extend('$text', {
        allowAttributes: 'mention'
      }); // Upcast conversion.

      editor.conversion.for('upcast').elementToAttribute({
        view: {
          name: 'span',
          key: 'data-mention',
          classes: 'mention'
        },
        model: {
          key: 'mention',
          value: function value(viewElement) {
            return _toMentionAttribute(viewElement);
          }
        }
      }); // Downcast conversion.

      editor.conversion.for('downcast').attributeToElement({
        model: 'mention',
        view: createViewMentionElement
      });
      editor.conversion.for('downcast').add(preventPartialMentionDowncast);
      doc.registerPostFixer(function (writer) {
        return removePartialMentionPostFixer(writer, doc, model.schema);
      });
      doc.registerPostFixer(function (writer) {
        return extendAttributeOnMentionPostFixer(writer, doc);
      });
      doc.registerPostFixer(function (writer) {
        return selectionMentionAttributePostFixer(writer, doc);
      });
      editor.commands.add('mention', new MentionCommand(editor));
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'MentionEditing';
    }
  }]);

  return MentionEditing;
}(Plugin);

export { MentionEditing as default };
export function _addMentionAttributes(baseMentionData, data) {
  return Object.assign({
    uid: uid()
  }, baseMentionData, data || {});
}
/**
 * Creates a mention attribute value from the provided view element and optional data.
 *
 * This function is exposed as
 * {@link module:mention/mention~Mention#toMentionAttribute `editor.plugins.get( 'Mention' ).toMentionAttribute()`}.
 *
 * @protected
 * @param {module:engine/view/element~Element} viewElementOrMention
 * @param {String|Object} [data] Mention data to be extended.
 * @returns {module:mention/mention~MentionAttribute}
 */

export function _toMentionAttribute(viewElementOrMention, data) {
  var dataMention = viewElementOrMention.getAttribute('data-mention');
  var textNode = viewElementOrMention.getChild(0); // Do not convert empty mentions.

  if (!textNode) {
    return;
  }

  var baseMentionData = {
    id: dataMention,
    _text: textNode.data
  };
  return _addMentionAttributes(baseMentionData, data);
} // A converter that blocks partial mention from being converted.
//
// This converter is registered with 'highest' priority in order to consume mention attribute before it is converted by
// any other converters. This converter only consumes partial mention - those whose `_text` attribute is not equal to text with mention
// attribute. This may happen when copying part of mention text.
//
// @param {module:engine/conversion/dwoncastdispatcher~DowncastDispatcher}

function preventPartialMentionDowncast(dispatcher) {
  dispatcher.on('attribute:mention', function (evt, data, conversionApi) {
    var mention = data.attributeNewValue;

    if (!data.item.is('$textProxy') || !mention) {
      return;
    }

    var start = data.range.start;
    var textNode = start.textNode || start.nodeAfter;

    if (textNode.data != mention._text) {
      // Consume item to prevent partial mention conversion.
      conversionApi.consumable.consume(data.item, evt.name);
    }
  }, {
    priority: 'highest'
  });
} // Creates a mention element from the mention data.
//
// @param {Object} mention
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
// @returns {module:engine/view/attributeelement~AttributeElement}


function createViewMentionElement(mention, _ref) {
  var writer = _ref.writer;

  if (!mention) {
    return;
  }

  var attributes = {
    class: 'mention',
    'data-mention': mention.id
  };
  var options = {
    id: mention.uid,
    priority: 20
  };
  return writer.createAttributeElement('span', attributes, options);
} // Model post-fixer that disallows typing with selection when the selection is placed after the text node with the mention attribute or
// before a text node with mention attribute.
//
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/document~Document} doc
// @returns {Boolean} Returns `true` if the selection was fixed.


function selectionMentionAttributePostFixer(writer, doc) {
  var selection = doc.selection;
  var focus = selection.focus;

  if (selection.isCollapsed && selection.hasAttribute('mention') && shouldNotTypeWithMentionAt(focus)) {
    writer.removeSelectionAttribute('mention');
    return true;
  }
} // Helper function to detect if mention attribute should be removed from selection.
// This check makes only sense if the selection has mention attribute.
//
// The mention attribute should be removed from a selection when selection focus is placed:
// a) after a text node
// b) the position is at parents start - the selection will set attributes from node after.


function shouldNotTypeWithMentionAt(position) {
  var isAtStart = position.isAtStart;
  var isAfterAMention = position.nodeBefore && position.nodeBefore.is('$text');
  return isAfterAMention || isAtStart;
} // Model post-fixer that removes the mention attribute from the modified text node.
//
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/document~Document} doc
// @returns {Boolean} Returns `true` if the selection was fixed.


function removePartialMentionPostFixer(writer, doc, schema) {
  var changes = doc.differ.getChanges();
  var wasChanged = false;

  var _iterator = _createForOfIteratorHelper(changes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var change = _step.value;
      // Checks the text node on the current position.
      var position = change.position;

      if (change.name == '$text') {
        var nodeAfterInsertedTextNode = position.textNode && position.textNode.nextSibling; // Checks the text node where the change occurred.

        wasChanged = checkAndFix(position.textNode, writer) || wasChanged; // Occurs on paste inside a text node with mention.

        wasChanged = checkAndFix(nodeAfterInsertedTextNode, writer) || wasChanged;
        wasChanged = checkAndFix(position.nodeBefore, writer) || wasChanged;
        wasChanged = checkAndFix(position.nodeAfter, writer) || wasChanged;
      } // Checks text nodes in inserted elements (might occur when splitting a paragraph or pasting content inside text with mention).


      if (change.name != '$text' && change.type == 'insert') {
        var insertedNode = position.nodeAfter;

        var _iterator2 = _createForOfIteratorHelper(writer.createRangeIn(insertedNode).getItems()),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            wasChanged = checkAndFix(item, writer) || wasChanged;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      } // Inserted inline elements might break mention.


      if (change.type == 'insert' && schema.isInline(change.name)) {
        var nodeAfterInserted = position.nodeAfter && position.nodeAfter.nextSibling;
        wasChanged = checkAndFix(position.nodeBefore, writer) || wasChanged;
        wasChanged = checkAndFix(nodeAfterInserted, writer) || wasChanged;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return wasChanged;
} // This post-fixer will extend the attribute applied on the part of the mention so the whole text node of the mention will have
// the added attribute.
//
// @param {module:engine/model/writer~Writer} writer
// @param {module:engine/model/document~Document} doc
// @returns {Boolean} Returns `true` if the selection was fixed.


function extendAttributeOnMentionPostFixer(writer, doc) {
  var changes = doc.differ.getChanges();
  var wasChanged = false;

  var _iterator3 = _createForOfIteratorHelper(changes),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var change = _step3.value;

      if (change.type === 'attribute' && change.attributeKey != 'mention') {
        // Checks the node on the left side of the range...
        var nodeBefore = change.range.start.nodeBefore; // ... and on the right side of the range.

        var nodeAfter = change.range.end.nodeAfter;

        for (var _i = 0, _arr = [nodeBefore, nodeAfter]; _i < _arr.length; _i++) {
          var node = _arr[_i];

          if (isBrokenMentionNode(node) && node.getAttribute(change.attributeKey) != change.attributeNewValue) {
            writer.setAttribute(change.attributeKey, change.attributeNewValue, node);
            wasChanged = true;
          }
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return wasChanged;
} // Checks if a node has a correct mention attribute if present.
// Returns `true` if the node is text and has a mention attribute whose text does not match the expected mention text.
//
// @param {module:engine/model/node~Node} node The node to check.
// @returns {Boolean}


function isBrokenMentionNode(node) {
  if (!node || !(node.is('$text') || node.is('$textProxy')) || !node.hasAttribute('mention')) {
    return false;
  }

  var text = node.data;
  var mention = node.getAttribute('mention');
  var expectedText = mention._text;
  return text != expectedText;
} // Fixes a mention on a text node if it needs a fix.
//
// @param {module:engine/model/text~Text} textNode
// @param {module:engine/model/writer~Writer} writer
// @returns {Boolean}


function checkAndFix(textNode, writer) {
  if (isBrokenMentionNode(textNode)) {
    writer.removeAttribute('mention', textNode);
    return true;
  }

  return false;
}